import React, { useEffect } from "react"
import { Carousel, Typography, Tag, Card } from "antd"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import CommonEmptyStateUI from "../CommonEmptyStateUI"
import styles from "./index.module.css"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { getGuideBoats } from "store/guide-profile"
import PhotoSlider from "components/common/PhotoSlider"
import FirstLoading from "modules/loader-watchers/FirstLoading"
const { Title, Text } = Typography

const GuideEquipment = () => {
  const dispatch = useDispatch()
  const { slug } = useParams()
  const equipmentData = useSelector((store) => store?.guideProfile?.boats?.data)
  const loading = useSelector((store) => store?.guideProfile?.boats?.loading)

  useEffect(() => {
    if (slug) {
      dispatch(getGuideBoats(slug))
    }
  }, [slug, dispatch])

  const hasItems = equipmentData?.data?.length > 0
  return (
    <FirstLoading loading={loading} name="guideProfile.boats">
      <div className={styles.guideEquipmentContainer}>
        <WithEmptyStateWrapper
          name="equipment"
          hasItems={hasItems}
          fallback={
            <CommonEmptyStateUI titleKey="guide.navigation.no_equipment" descKey="guide.navigation.equipment_will_be_displayed_here" />
          }
        >
          <Carousel
            dotPosition="bottom"
            dots={equipmentData?.data?.length > 2 ? { className: styles.dots } : false}
            slidesToShow={Math.min(2, equipmentData?.data?.length)}
            slidesToScroll={1}
            infinite={false}
            arrows={false}
            lazyLoad="ondemand"
            swipeToSlide={true}
            draggable={true}
            centerMode={false}
            autoplay={false}
            autoplaySpeed={2000}
            gap={20}
            responsive={[
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: Math.min(2, equipmentData?.data?.length),
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: "40px"
                }
              }
            ]}
          >
            {equipmentData?.data?.map((item) => (
              <div key={item.id} className={styles.equipmentCard}>
                <Card>
                  <div className={styles.equipmentCarousel}>
                    <PhotoSlider photos={item?.properties} cropped_photos={item.cropped_photos} preview className="w-full h-full" />
                  </div>

                  <div className={styles.equipmentDetails}>
                    <Title level={4} className={styles.equipmentName}>
                      {item.name}
                    </Title>
                    <Text className={styles.equipmentDescription}>{item.description}</Text>

                    <div className={styles.equipmentTags}>
                      {item?.custom_info?.map((tag) => (
                        <Tag key={tag} className={styles.equipmentTag}>
                          {tag}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </Carousel>
        </WithEmptyStateWrapper>
      </div>
    </FirstLoading>
  )
}

export default GuideEquipment
